import * as React from "react";
import ReactGA from "react-ga";
import { connect } from "react-redux";
import DeletePopup from "../../components/DeletePopup";
import { Redirect } from "react-router";
import { bindActionCreators } from "redux";
import * as adminActionCreators from "./actionCreators";
import * as draftListActionCreators from "../DraftRegistration/actionCreators";
import * as submittedListActionCreators from "../SubmittedWarranties/actionCreators";
import * as myCartActionCreators from "../MyCart/actionCreators";
import * as dynamicActionCreators from "../DynamicForm/actionCreators";
import * as globalActionsCreators from "../../globalStore/actions";
import IAdminDashboardProps from "./IAdminDashboard";
import constantFile from "../../constants/constantFile";
// import searchIcon from "../../../assets/images/search.png";
import "../../../assets/sass/components/adminDashboard.scss";
import View from "../View";
import AccessDenied from "../../widgets/AccessDenied";
import {
    getCustomerIDFromURL,
    getSessionValue,
    getCustomerIDFromStore,
    redirectToCCZ,
    loadGoogleMapAPI,
    handleRedirectAuth,
    imagePathurl
} from "../../utils/utils";

import { CREATE_ANOTHER } from "../../constants/storageKeys";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const Loadable = require("react-loadable");

const BSTable = Loadable({
    loader: () => import("../BSTable"),
    loading() {
        return <div>Loading...</div>;
    },
});

interface IAdminDashboardPropsState {
    warrantyID?: any;
    searchItem?: any;
    TableRowSelection?: any;
    adminChecks?: boolean;
    redirectToMyCart: boolean;
    offSet?: any;
    sortOrder?: any;
    pageSize?: any;
    sortBy?: any;
    searchRecords?: any;
    errors: any;
}

class AdminDashboard extends React.Component<IAdminDashboardProps, IAdminDashboardPropsState> {
    constructor(props: IAdminDashboardProps) {
        super(props);
        this.state = {
            warrantyID: undefined,
            searchItem: undefined,
            TableRowSelection: undefined,
            redirectToMyCart: false,
            adminChecks: false,
            offSet: 0,
            sortOrder: "asc",
            pageSize: 10,
            sortBy: "ContractorId",
            errors: { error: false, message: [] },
        };
    }
    isHandleClickCalled = false;

    componentDidMount() {
        const {
            adminActions,
            layoutResponse: { JSONSchema, UISchema, ErrorSchema },
        } = this.props;
        const { fetchUserInfo, fetchSearchRecords } = adminActions;
        if (getSessionValue(CREATE_ANOTHER)) {
            fetchUserInfo({ isFromThankyouPage: true, statusCode: 1 });
        } else {
            fetchUserInfo({ isFromThankyouPage: false });
        }
        loadGoogleMapAPI();
        if (!JSONSchema || !UISchema || !ErrorSchema) {
            this.props.dynamicActions.fetchFormLayoutData({ payload: "Residential Warranty" });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            userInfo,
            tempContractorSelection,
            selectedWarrantyDetails,
            searchRecords,
            deletePopupContent: { showPopup },
            draftListActions: { updateDeletePopup },
            myCartActions: { getActiveShoppingCartSuccess },
            adminActions: { fetchContractorStatus },
        } = this.props;
        const { contractorSelection: oldTempContractorSelection } = prevProps;
        if (prevProps.userInfo !== userInfo && (userInfo.isAdmin || userInfo.isTm)) {
            this.setState({ adminChecks: true });
        }
        if (oldTempContractorSelection !== tempContractorSelection) {
            if (tempContractorSelection.isActive) {
                this.onTableRowClickConfirm(tempContractorSelection);
            } else if (!showPopup) {
                const object = {
                    title: constantFile.inActiveContractorTitle,
                    description: constantFile.inActiveContractorDescription,
                    buttonText: constantFile.inActiveContractorButtonText,
                    dataInfo: tempContractorSelection,
                    showPopup: true,
                    confirm: false,
                };
                updateDeletePopup({ payload: object });
            }
        }
        if (
            prevProps.warrantyExistStatus !== this.props.warrantyExistStatus &&
            this.props.warrantyExistStatus.StatusCode === 404
        ) {
            this.setState({
                errors: { error: true, message: this.props.warrantyExistStatus.Message },
            });
        }
        if (prevProps.selectedWarrantyDetails !== selectedWarrantyDetails) {
            if (
                selectedWarrantyDetails &&
                selectedWarrantyDetails.contractor &&
                selectedWarrantyDetails.contractor.isActive
            ) {
                if (selectedWarrantyDetails.shoppingCartId) {
                    getActiveShoppingCartSuccess({
                        data: { shoppingCartId: selectedWarrantyDetails.shoppingCartId, disableActions: true },
                    });
                    this.onShoppingCartSelectionConfirm(selectedWarrantyDetails);
                    this.setState({
                        redirectToMyCart: true,
                    });
                } else {
                    this.onWarrantySelectionConfirm(selectedWarrantyDetails);
                }
            } else if (selectedWarrantyDetails && selectedWarrantyDetails.contractor && !showPopup) {
                const object = {
                    title: constantFile.inActiveContractorTitle,
                    description: constantFile.inActiveContractorDescription,
                    buttonText: constantFile.inActiveContractorButtonText,
                    dataInfo: selectedWarrantyDetails,
                    showPopup: true,
                    confirm: false,
                };
                updateDeletePopup({ payload: object });
            }
        }
    }

    onShoppingCartSelectionConfirm = (selectedDetails) => {
        const {
            adminActions: { updateContractorSelection },
        } = this.props;
        const contractorObj = {};
        contractorObj["activeStatus"] = selectedDetails.contractor.isActive ? "Active" : "Inactive";
        contractorObj["contractorId"] = selectedDetails.contractor.contractorId;
        contractorObj["contractorName"] = selectedDetails.contractor.contractorName;
        contractorObj["customerId"] = selectedDetails.contractor.customerId;
        const contractorAddress = selectedDetails.contractor.addresses.filter((address) => {
            // address.addressType &&
            return address.addressType === "1" || address.addressType === null;
        });
        contractorObj["region"] = contractorAddress.length
            ? contractorAddress[0].city + ", " + contractorAddress[0].stateOrProvince
            : "N/A";
        updateContractorSelection(contractorObj);
        this.onselectWarrantyPopupClose();
    };

    onWarrantySelectionConfirm = (warrantySelection) => {
        const jsonSchema = warrantySelection.jsonSchema
            ? typeof warrantySelection.jsonSchema === "object"
                ? warrantySelection.jsonSchema
                : JSON.parse(warrantySelection.jsonSchema)
            : {};
        const UISchema = warrantySelection.uiSchema
            ? typeof warrantySelection.uiSchema === "object"
                ? warrantySelection.uiSchema
                : JSON.parse(warrantySelection.uiSchema)
            : {};
        // var errorSchema = typeof(warrantySelection.errorSchema) === 'object' ? warrantySelection.errorSchema : JSON.parse(warrantySelection.errorSchema);
        const errorSchema = warrantySelection.errorSchema
            ? typeof warrantySelection.errorSchema === "object"
                ? warrantySelection.errorSchema
                : JSON.parse(warrantySelection.errorSchema)
            : [];
        const WarrantyData =
            typeof warrantySelection.warrantyData === "object"
                ? warrantySelection.warrantyData.formData
                : JSON.parse(warrantySelection.warrantyData).formData;
        WarrantyData.residentialWarrantyForm.NavigationMenu = "RP";
        const result = {
            id: warrantySelection.id,
            forminstanceTypeId: warrantySelection.forminstanceTypeId,
            JSONSchema: jsonSchema,
            UISchema: UISchema,
            ErrorSchema: errorSchema,
            WarrantyData,
        };
        const contractorObj = {};
        contractorObj["activeStatus"] = warrantySelection.contractor.isActive ? "Active" : "Inactive";
        contractorObj["contractorId"] = warrantySelection.contractor.contractorId;
        contractorObj["contractorName"] = warrantySelection.contractor.contractorName;
        contractorObj["customerId"] = warrantySelection.contractor.customerId;
        const contractorAddress = warrantySelection.contractor.addresses.filter((address) => {
            // address.addressType &&
            return address.addressType === "1" || address.addressType === null;
        });
        contractorObj["region"] = contractorAddress.length
            ? contractorAddress[0].city + ", " + contractorAddress[0].stateOrProvince
            : "N/A";
        const {
            dynamicActions: { fetchSavedFormLayoutDataSuccess },
            adminActions: { updateContractorSelection, updateFormSubmittedStatus, updateWaiverReceived },
        } = this.props;
        this.isHandleClickCalled = false;
        fetchSavedFormLayoutDataSuccess({ value: result });
        updateContractorSelection(contractorObj);
        updateWaiverReceived(warrantySelection.waiverreceived);
        updateFormSubmittedStatus(true);
        this.onselectWarrantyPopupClose();
    };

    onselectWarrantyPopupClose = () => {
        const {
            draftListActions: { updateDeletePopup },
            adminActions: { fetchWarrantyDetailsSuccess },
        } = this.props;
        const object = {
            ...this.props.deletePopupContent,
            title: "",
            description: "",
            buttonText: "",
            dataInfo: {},
            showPopup: false,
            confirm: false,
        };
        this.isHandleClickCalled = false;
        fetchWarrantyDetailsSuccess({});
        updateDeletePopup({ payload: object });
        document.body.classList.remove("hideOverflow");
    };

    onWarrantyIDSelect = () => {
        const {
            adminActions: { fetchWarrantyDetails },
        } = this.props;
        const { warrantyID } = this.state;
        if (this.isHandleClickCalled) {
            return;
        }
        if (warrantyID) {
            this.isHandleClickCalled = true;
            fetchWarrantyDetails(warrantyID);
        } else {
            this.setState({ errors: { error: true, message: constantFile.adminNoWarrantyIdErrorMessage } });
        }
    };

    onSearch = (searchItem) => {
        const {
            adminActions: { fetchSearchRecords, resetFetchSearchRecords },
        } = this.props;

        this.setState(
            {
                searchItem,
                sortOrder: "asc",
                pageSize: 10,
                offSet: 0,
            },
            () => {
                if (searchItem && searchItem.trim()) {
                    const searchObj = {
                        searchItem,
                        offSet: this.state.offSet,
                        pageSize: this.state.pageSize,
                    };
                    fetchSearchRecords(searchObj);
                } else {
                    resetFetchSearchRecords();
                }
            }
        );
    };

    onTableRowClick = (rowObj) => {
        // const { draftListActions } = this.props;
        // if (rowObj["activeStatus"] === "Inactive") {
        //     this.setState({ TableRowSelection: rowObj }, () => {
        //         const object = {
        //             title: constantFile.inActiveContractorTitle,
        //             description: constantFile.inActiveContractorDescription,
        //             buttonText: constantFile.inActiveContractorButtonText,
        //             dataInfo: rowObj,
        //             showPopup: true,
        //             confirm: false,
        //         };
        //         draftListActions.updateDeletePopup({ payload: object });
        //     });
        // } else {
        //     this.onTableRowClickConfirm(rowObj);
        // }
        const {
            adminActions: { fetchContractorStatus },
            submittedListActions: { updateActiveTab, resetSubmittedWarrantyList },
            searchRecords,
        } = this.props;
        updateActiveTab("draft");
        resetSubmittedWarrantyList();
        const selectedItem = searchRecords.filter((record) => record.contractorId === rowObj.contractorId);
        this.setState({ TableRowSelection: selectedItem[0] });
        rowObj.customerId = selectedItem[0].customerId;
        fetchContractorStatus(rowObj);
    };

    onTableRowClickConfirm = (TableRowSelection) => {
        window["AppInsightTrace"].trackEvent(`On contractor selection`);
        ReactGA.event({
            category: "Admin Access",
            action: "Admin Dashboard: Recent Contractor Selected",
            label: `Admin Dashboard: Recent Contractor Selected: ${TableRowSelection.contractorId}`,
        });
        const {
            adminActions: { updateContractorSelection },
        } = this.props;
        // Modify the contractor Selection as needed
        const contractorObject = {};
        contractorObject["activeStatus"] = TableRowSelection.isActive ? "Active" : "Inactive";
        contractorObject["contractorId"] = TableRowSelection.contractorId;
        contractorObject["contractorName"] = TableRowSelection.contractorName;
        contractorObject["customerId"] = TableRowSelection.customerId;
        const contractorAddress = TableRowSelection.addresses.filter((address) => {
            // address.addressType &&
            return address.addressType === "1" || address.addressType === null;
        });
        contractorObject["region"] = contractorAddress.length
            ? contractorAddress[0].city + ", " + contractorAddress[0].stateOrProvince
            : "N/A";
        if (!this.props.userInfo.isTm) this.props.globalActions.updateActiveScreen("draftList");
        updateContractorSelection(contractorObject);
        this.onPopupClose();
        // this.props.history.push(`/?contractorId=${TableRowSelection.contractorId}`);
    };

    onPopupClose = () => {
        const {
            draftListActions: { updateDeletePopup },
        } = this.props;
        const object = {
            ...this.props.deletePopupContent,
            title: "",
            description: "",
            buttonText: "",
            dataInfo: {},
            showPopup: false,
            confirm: false,
        };
        updateDeletePopup({ payload: object });
        document.body.classList.remove("hideOverflow");
        this.setState({ TableRowSelection: {} });
    };

    prepareTableData(tableRecords) {
        const BSTableData = [];
        tableRecords.map((contractorItem) => {
            const newItem = {};
            newItem["activeStatus"] = contractorItem.isActive ? "Active" : "Inactive";
            newItem["contractorId"] = contractorItem.contractorId;
            newItem["contractorName"] = contractorItem.contractorName;
            const contractorAddress = contractorItem.addresses.filter((address) => {
                // address.addressType &&
                return address.addressType === "1" || address.addressType === null;
            });
            newItem["region"] = contractorAddress.length
                ? contractorAddress[0].city + ", " + contractorAddress[0].stateOrProvince
                : "N/A";
            BSTableData.push(newItem);
        });
        return BSTableData;
    }

    onTableDataChange = (offset, sortField, sortBy) => {
        const {
            adminActions: { fetchSearchRecords },
        } = this.props;
        if (sortField === "region") {
            sortField = "State";
        } else if (sortField === "contractorName") {
            sortField = "ContractorName";
        } else if (sortField === "contractorId") {
            sortField = "ContractorId";
        }
        fetchSearchRecords({
            searchItem: this.state.searchItem,
            pageSize: this.state.pageSize,
            offSet: offset - 1,
            sort: sortBy,
            sortBy: sortField,
        });
        this.setState({
            offSet: offset - 1,
            sortBy: sortField,
            sortOrder: sortBy,
        });
    };

    changeWarrantyId = (e) => {
        this.setState(
            {
                warrantyID: e.target.value,
                errors: { error: false, message: "" },
            },
            () => {
                this.props.adminActions.invalidWarrentyIdEntry({
                    data: { Message: "", StatusCode: 200 },
                });
            }
        );
        this.isHandleClickCalled = false;
    };

    render() {
        const getimagePath = imagePathurl();
        const {
            userInfo,
            contractorInfo,
            searchRecords,
            screenResolution,
            selectedWarrantyDetails,
            deletePopupContent: { title, description, buttonText, showPopup },
            paginationDetails,
            accessDeniedError,
        } = this.props;
        const { warrantyID, searchItem, TableRowSelection } = this.state;
        const tableColumns = constantFile.contractorListTableColumns;
        const paginationObject = constantFile.contractorListPaginationObject;
        const BSTableData = searchRecords.length > 0 ? this.prepareTableData(searchRecords) : [];
        const addWarrantySearchPadding = userInfo && userInfo.isAdmin && !contractorInfo;
        if (userInfo && Object.keys(userInfo).length > 0) {
            if (!getCustomerIDFromURL() && !this.props.contractorInfo) {
                const customerID = getCustomerIDFromStore(true);
                if (customerID) {
                    const newRoute = `/?customerID=${customerID}`;
                    return <Redirect to={newRoute} />;
                } else if (this.props.userInfo && (this.props.userInfo.isAdmin || this.props.userInfo.isTm)) {
                    // don't do anything this.props.globalActions.updateLoading(false);
                } else {
                    redirectToCCZ();
                    return null;
                }
            }
        }
        if (this.state.redirectToMyCart) {
            return <Redirect to="/myCart" />;
        }
        const content =
            userInfo && (userInfo.isAdmin || userInfo.isTm) ? (
                contractorInfo ? (
                    <View />
                ) : (
                    <>
                        <div className="admin-dashboard-container-sec">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 warranty-search">
                                {userInfo.isAdmin && (
                                    <div>
                                        <div className="form-title">Find submitted Warranties or ShoppingCart</div>
                                        {screenResolution.width > 768 ? (
                                            <div className="form-subtitle">
                                                Enter a Warranty # to edit, resubmit or cancel a submitted Warranty.
                                                <br/>
                                                Enter a Shopping Cart # to resubmit or cancel a submitted Shopping Cart.
                                            </div>
                                        ) : null}
                                        <div className="user-actions">
                                            <div
                                                className={
                                                    this.state.errors.error
                                                        ? "inputbox-rectangle inputbox-rectangle-error"
                                                        : "inputbox-rectangle"
                                                }
                                            >
                                                <input
                                                    className="gaf-inputBox"
                                                    type="number"
                                                    placeholder="Enter warranty number"
                                                    value={warrantyID}
                                                    onChange={(e) => this.changeWarrantyId(e)}
                                                />
                                                {this.state.errors.error && (
                                                    <div className="error-message">{this.state.errors.message}</div>
                                                )}
                                            </div>
                                            <button className="gaf-button-template" onClick={this.onWarrantyIDSelect}>
                                                Go
                                            </button>
                                            {Object.keys(selectedWarrantyDetails).length !== 0 && (
                                                <div>
                                                    {showPopup && (
                                                        <DeletePopup
                                                            popupStatus={showPopup}
                                                            popupTitle={title}
                                                            popupDescription={description}
                                                            buttonText={buttonText}
                                                            onConfirm={() =>
                                                                this.onWarrantySelectionConfirm(selectedWarrantyDetails)
                                                            }
                                                            onCancel={() => this.onselectWarrantyPopupClose()}
                                                        />
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="contractor-new-registration">
                                <div className="registration-container">
                                    <div className="form-title">Contractors for new registrations</div>
                                    <div className="search-box">
                                        <input
                                            type="text"
                                            className="gaf-inputBox"
                                            placeholder="Search by keyword"
                                            value={searchItem}
                                            onChange={(e) => this.setState({ searchItem: e.target.value })}
                                            onKeyPress={(event) => {
                                                if (event.key === "Enter") {
                                                    this.onSearch(searchItem);
                                                }
                                            }}
                                        />
                                        <img
                                            className="search-icon"
                                            src={`${getimagePath}search.png`}
                                            alt="search"
                                            onClick={() => this.onSearch(searchItem)}
                                        />
                                    </div>
                                </div>
                                {userInfo.isTm && (
                                    <p className="tm-search-help-text">{constantFile.tm.searchHelpText}</p>
                                )}
                                {BSTableData.length !== 0 && (
                                    <div>
                                        {TableRowSelection && TableRowSelection.contractorId && showPopup && (
                                            <DeletePopup
                                                popupStatus={showPopup}
                                                popupTitle={title}
                                                popupDescription={description}
                                                buttonText={buttonText}
                                                onConfirm={() => this.onTableRowClickConfirm(TableRowSelection)}
                                                onCancel={() => this.onPopupClose()}
                                            />
                                        )}
                                        {screenResolution.width >= 768 && (
                                            <div>
                                                <BSTable
                                                    hover
                                                    striped
                                                    sortable
                                                    bordered={false}
                                                    tableColumnData={tableColumns}
                                                    tableRowData={BSTableData}
                                                    tableRowClick={this.onTableRowClick}
                                                    pagination={paginationObject}
                                                    onTableDataChange={this.onTableDataChange}
                                                    paginationDetails={paginationDetails}
                                                />
                                            </div>
                                        )}
                                        {screenResolution.width < 768 && (
                                            <div>
                                                <div className="item-list">
                                                    {BSTableData.map((tableItem, index) => {
                                                        return (
                                                            <div
                                                                key={`menuitem${index}`}
                                                                className="item d-flex menu-item"
                                                                onClick={() => this.onTableRowClick(tableItem)}
                                                            >
                                                                <div className="flex-coloumn w-100">
                                                                    <div className="contractor-details">{`${tableItem.contractorId} - ${tableItem.contractorName}`}</div>
                                                                    <div className="contractor-region">
                                                                        {tableItem.region}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </>
                )
            ) : (
                <View />
            );

        return userInfo && Object.keys(userInfo).length > 0 ? (
            <>
                <div
                    className={`${this.state.adminChecks ? "admin-dashboard-container " : ""} ${
                        addWarrantySearchPadding ? "pt100" : ""
                    }`}
                >
                    {content}
                </div>
            </>
        ) : accessDeniedError ? (
            <AccessDenied
                type={accessDeniedError ? "error" : ""}
                message={accessDeniedError}
                alertBoxClose={handleRedirectAuth}
            />
        ) : null;
    }
}

export function mapStateToProps(state) {
    return {
        userInfo: state.adminData.userInfo,
        isSubmittedForm: state.adminData.isSubmittedForm,
        contractorInfo: state.adminData.contractorSelection,
        tempContractorSelection: state.adminData.tempContractorSelection,
        searchRecords: state.adminData.searchRecords.tableData,
        paginationDetails: state.adminData.searchRecords.paginationDetails,
        screenResolution: state.globalInfo.screenResolution,
        deletePopupContent: state.draftListInfo.deletePopup,
        warrantyExistStatus: state.adminData.warrantyExistStatus,
        selectedWarrantyDetails: state.adminData.selectedWarrantyDetails,
        accessDeniedError: state.globalInfo.accessDeniedError,
        layoutResponse: state.dynamicFormInfo.layoutResponse,
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        adminActions: bindActionCreators(adminActionCreators, dispatch),
        dynamicActions: bindActionCreators(dynamicActionCreators, dispatch),
        draftListActions: bindActionCreators(draftListActionCreators, dispatch),
        submittedListActions: bindActionCreators(submittedListActionCreators, dispatch),
        myCartActions: bindActionCreators(myCartActionCreators, dispatch),
        globalActions: bindActionCreators(globalActionsCreators, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminDashboard);
